"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrices = exports.bucketStddev = exports.bucketAverage = void 0;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _helpers = require("./helpers");
// Approximates price average by buckets
var bucketAverage = buckets => {
  var {
    count,
    sum
  } = (0, _reduce.default)(buckets).call(buckets, (res, _ref) => {
    var {
      price,
      total
    } = _ref;
    return {
      sum: res.sum + price * total,
      count: res.count + total
    };
  }, {
    sum: 0,
    count: 0
  });
  return count > 0 ? sum / count : 0;
};

// Approximages price standard deviation by buckets
exports.bucketAverage = bucketAverage;
var bucketStddev = buckets => {
  if (!buckets.length) return undefined;
  var avg = bucketAverage(buckets);
  var {
    count,
    sum
  } = (0, _reduce.default)(buckets).call(buckets, (res, _ref2) => {
    var {
      price,
      total
    } = _ref2;
    return {
      sum: res.sum + (price - avg) ** 2 * total,
      count: res.count + total
    };
  }, {
    sum: 0,
    count: 0
  });
  return Math.sqrt(sum / count);
};
exports.bucketStddev = bucketStddev;
var priceCaps = {
  default: 5000000,
  COMSAL: 100000000,
  COMLSE: 200000,
  REN: 260714,
  HOL: 260714
};

/*
 * Find price caps by types for price slider
 */
var findPriceCap = typeMap => {
  var _context;
  var priceCap = (0, _reduce.default)(_context = (0, _keys.default)(typeMap)).call(_context, (result, key) => {
    if (result) return result;
    return priceCaps[key];
  }, null);
  return priceCap || priceCaps.default;
};

/*
 * Build price array for price slider
 * Prices of all applicable typeCodes are merged, sorted, caped and and filled to
 * provide an even range without any increments missing
 * @param {Object} typeKey The listings ordered by typeCode > statusCode
 * @param {String} typeCode The page's typeCode
 * @param {String} subTypeCode The page's subTypeCode
 * @param {String} statusCode The page's statusCode
 * @params {boolean} isRent Indicates whether or not the site displays
 * rent types and needs rental prices
 *
 * @return {Array} An array of the site's price range
 */
var getPrices = function (typeKey, typeCode, subTypeCode, statusCode, PRICE_INTERVAL, RENT_PRICE_INTERVAL) {
  var _context2, _context3, _context4;
  var isRent = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  if (!typeKey) return [];
  var typeMap = (0, _helpers.mapMetaTypeCodes)(typeCode, subTypeCode);
  var priceCap = findPriceCap(typeMap);

  // Merge prices for all wanted typeCodes
  var merged = (0, _reduce.default)(_context2 = (0, _keys.default)(typeMap)).call(_context2, (result, code) => {
    var nextType = typeKey[code];
    var _statusCode = (0, _isArray.default)(statusCode) ? statusCode : [statusCode];
    if (!nextType) return result;
    var next;
    (0, _forEach.default)(_statusCode).call(_statusCode, status => {
      var current = nextType.statusCode[status];
      if (current) {
        next = isRent ? current.rentPrices : current.prices;
      }
    });
    if (!next || !next.length) return result;
    result.push(...next);
    return result;
  }, []);
  if (!merged.length) return [];
  var _merged = [...merged];
  var cache = {};

  // Merge objects with duplicate prices by adding up the total values
  (0, _forEach.default)(_merged).call(_merged, current => {
    var {
      price,
      total
    } = current;
    if (!cache[price]) {
      cache[price] = total;
      return;
    }
    cache[price] += total;
  });
  var sorted = (0, _map.default)(_context3 = (0, _sort.default)(_context4 = (0, _keys.default)(cache)).call(_context4, (a, b) => (0, _parseInt2.default)(a, 10) - (0, _parseInt2.default)(b, 10))).call(_context3, key => ({
    total: cache[key],
    price: (0, _parseInt2.default)(key, 10)
  }));

  // Find outliners at top and bottom
  var priceStdDev = bucketStddev(sorted);
  var priceAverage = bucketAverage(sorted);
  var numStdDevs = 2;
  var calculatedMax = priceAverage + numStdDevs * priceStdDev;
  var maximum = calculatedMax < priceCap ? calculatedMax : priceCap;
  var aboveMax = 0;

  // Filter out outliners
  var ranged = (0, _filter.default)(sorted).call(sorted, _ref3 => {
    var {
      price,
      total
    } = _ref3;
    if (price > maximum) aboveMax += total;
    return !(price > maximum);
  });

  // If there aren't any prices, bail
  if (!ranged.length) return [];

  // Merge outliners into last price item
  var maxItem = {
    price: ranged[ranged.length - 1].price,
    total: ranged[ranged.length - 1].total += aboveMax
  };

  // Fill in any missing prices
  var INCREMENT = !isRent ? PRICE_INTERVAL : RENT_PRICE_INTERVAL;
  var lastPrice;
  var parsed = (0, _reduce.default)(ranged).call(ranged, (previous, current) => {
    var {
      price
    } = current;
    lastPrice = lastPrice || price;
    var diff = price - lastPrice;
    if (diff > INCREMENT) {
      var increments = diff / INCREMENT;
      for (var i = 1; i < increments; i++) {
        previous.push({
          total: 0,
          price: lastPrice + i * INCREMENT
        });
      }
    }
    previous.push(current);
    lastPrice = price;
    return previous;
  }, []);
  var result = [...(0, _slice.default)(parsed).call(parsed, 0, parsed.length - 1), maxItem];
  return result;
};
exports.getPrices = getPrices;